import Vue from 'vue';
import TwentyTwenty from './TwentyTwenty.vue';

Vue.component('TwentyTwenty', TwentyTwenty);

export default TwentyTwenty;
